import {productDetailsSettings, ProductDetailsSettings} from '../../../bps/components/productDetails/productDetailsSettings';

productDetailsSettings.flags.src.boxSetImage = '/assets/tesdorpf/frontend-core/staticImages/wood-box.png';
productDetailsSettings.flags.whitelist = ['new', 'newVintage', 'award', 'stoerer', 'boxSetLayer'];

export {productDetailsSettings, ProductDetailsSettings};
